import Snackbar from '@dev-togetherprice/components.snackbar';
import useRegisteredTranslation from '@dev-togetherprice/hooks.use-register-translation';
import React from 'react';
import en from '../../i18n/en.json';
import es from '../../i18n/es.json';
import it from '../../i18n/it.json';
import pt from '../../i18n/pt.json';
const TRANSLATIONS = { en, es, it, pt };
const CannotCreateError = ({ open, setOpen }) => {
    const { t } = useRegisteredTranslation('PageWrapper', TRANSLATIONS);
    return (React.createElement(Snackbar, { variant: 'error', message: t('cannotCreatePost'), open: open, onClose: () => setOpen(false) }));
};
export default CannotCreateError;
